import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=451a37fd&"
import script from "./PromotionCard.vue?vue&type=script&lang=ts&"
export * from "./PromotionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports